import { Directive, HostListener } from '@angular/core';

/**
 * Directiva que restringe la entrada de un campo a valores numéricos con hasta
 * dos decimales, bloqueando cualquier otra tecla durante el evento `keypress`.
 */
@Directive({
  selector: '[appBlockLetters]'
})
export class BlockLettersDirective {
  constructor() { }

  /**
   * Bloquea la pulsación de teclas que no correspondan a un número con hasta dos decimales.
   * @param e - Evento de teclado que se evalúa y, en su caso, se cancela.
   */
  @HostListener('keypress', ['$event']) blockNumbers(e: KeyboardEvent) {
    var regexp = /^\d*\.?\d{0,2}$/;

    if (!regexp.test(e.key)) {
      e.preventDefault();
    }
  }
}
